import { useAnalytics } from "@keiko-app/react-google-analytics";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useGAPageView() {
	const analytics = useAnalytics();
	const location = useLocation();

	// biome-ignore lint/correctness/useExhaustiveDependencies: location.pathname is the trigger
	useEffect(() => {
		analytics?.tracker?.trackPageView?.({});
	}, [location.pathname, analytics]);
}
